<template>
	<div class="app-shell">
		<app-header v-if="!isLoginRoute" />
		<main class="app-content">
			<router-view />
			<app-notification-container />
			<app-upload-queue-panel />
		</main>
	</div>
</template>

<script setup lang="ts">
import {
	computed,
	onMounted,
	watch
} from "vue";
import { useRoute } from "vue-router";
import { useSignalR } from "@/composables/useSignalR";
import { useDocumentTitle } from "@/composables/useDocumentTitle";
import { useSoundAlert } from "@/composables/useSoundAlert";
import { useAngularBridge } from "@/composables/useAngularBridge";
import { rootStore } from "@/store/index";
import AppNotificationContainer from "@/components/ui-kit/notifications/AppNotificationContainer.vue";
import AppUploadQueuePanel from "@/components/ui-kit/upload/AppUploadQueuePanel.vue";
import AppHeader from "@/components/layout/AppHeader/AppHeader.vue";

const route = useRoute()
const root = rootStore()
const { init: initSignalR } = useSignalR()

useDocumentTitle()
// Звуки создаём сразу, а не при первом событии сокета: на телефоне их разблокирует первое же касание.
useSoundAlert()
// Приём сообщений от Angular-гостя: язык, сессия, переходы на Клиента/Проекта.
useAngularBridge()

const isLoginRoute = computed(() => route.path === '/login')

let signalRStarted = false
const startSignalROnce = () => {
	if (!signalRStarted && root.jwtToken) {
		signalRStarted = true
		initSignalR()
	}
}
onMounted(() => startSignalROnce())
watch(() => root.jwtToken, () => startSignalROnce())
</script>

<style scoped>
.app-shell {
	display: flex;
	flex-direction: column;
	height: 100vh;
	width: 100vw;
	overflow: hidden;
}

.app-content {
	flex: 1;
	min-height: 0;
	background: #F2F2F2;
	overflow: hidden;
	position: relative;
}

@media (max-width: 768px) {
	.app-shell {
		display: flex;
		flex-direction: column;
		height: 100dvh;
		max-height: 100dvh;
		width: 100vw;
		overflow: hidden;
	}

	.app-content {
		overscroll-behavior: none;
	}
}
</style>
